/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How portfolios of this type are created. SERVICE_AGREEMENT: with a linked service agreement, in the service agreement Ready for Configuration flow. STANDALONE: without a service agreement, from the portfolio overview screen.
 * 
 * @export
 */
export const PortfolioCreationFlow = {
    ServiceAgreement: 'SERVICE_AGREEMENT',
    Standalone: 'STANDALONE'
} as const;
export type PortfolioCreationFlow = typeof PortfolioCreationFlow[keyof typeof PortfolioCreationFlow];


export function instanceOfPortfolioCreationFlow(value: any): boolean {
    for (const key in PortfolioCreationFlow) {
        if (Object.prototype.hasOwnProperty.call(PortfolioCreationFlow, key)) {
            if (PortfolioCreationFlow[key as keyof typeof PortfolioCreationFlow] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioCreationFlowFromJSON(json: any): PortfolioCreationFlow {
    return PortfolioCreationFlowFromJSONTyped(json, false);
}

export function PortfolioCreationFlowFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCreationFlow {
    return json as PortfolioCreationFlow;
}

export function PortfolioCreationFlowToJSON(value?: PortfolioCreationFlow | null): any {
    return value as any;
}

export function PortfolioCreationFlowToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioCreationFlow {
    return value as PortfolioCreationFlow;
}

